import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { runtimeConfig } from '@/config/runtimeConfig';

interface ClubState {
  activeClubId: string;
  setActiveClub: (id: string) => void;
}

export const useClubStore = create<ClubState>()(
  persist(
    (set) => ({
      activeClubId: runtimeConfig.defaultClubId,
      setActiveClub: (id) => set({ activeClubId: id }),
    }),
    { name: 'bpc.club' },
  ),
);
